import ROLES from '@/utils/roles';
import TOP_BARS from '@topBars';
let routes = [
  /**
   * @description 选择会场志愿
   * @function /course/wish 选择会场志愿
   * @param { Component } PlaceWish views/student/Course/PlaceWish
   * @param { Name } pathname course-place-wish
   */
  {
    path: '/course/wish',
    name: 'course-place-wish',
    meta: {
      title: '选择会场志愿',
      role: ROLES.STUDENT,
      topBar: TOP_BARS.DEFAULT
    },
    component: () => import('@/views/student/Course/PlaceWish')
  },
  /**
   * @description 历史 onboarding 入口，重定向至 list（介绍为 Select 首步，见 views/Course/List/Select/Onboarding）
   * @function /course/onboarding 选课 onboarding
   * @param { Name } pathname course-onboarding
   */
  {
    path: '/course/onboarding',
    name: 'course-onboarding',
    redirect: { name: 'course-list' }
  },
  /**
   * @description 课程列表
   * @function /course/list 课程列表
   * @param { Component } List views/Course/List
   * @param { Name } pathname course-list
   */
  {
    path: '/course/list',
    name: 'course-list',
    meta: {
      title: '课程列表'
    },
    component: () => import('@/views/Course/List')
  },
  {
    path: '/course/workspace',
    name: 'course-workspace',
    meta: {
      title: '课程工作台'
    },
    component: () => import('@/views/Course/Workspace')
  },
  {
    path: '/course/workspace/capstone-report/:id',
    name: 'course-workspace-capstone-report',
    component: () => import('@/views/Course/Workspace/Student/SubmitCPReport')
  },
  {
    path: '/course/workspace/capstone-reflection/:id',
    name: 'course-workspace-capstone-reflection',
    component: () => import('@/views/Course/Workspace/Student/SubmitCPReflection')
  },
  {
    path: '/course/office-hour',
    name: 'course-office-hour',
    meta: {
      title: 'Office Hour 教室',
      role: ROLES.STUDENT,
      topBar: TOP_BARS.BACK,
      backDefault: {
        name: 'dashboard',
        query: {
          tab: 'COURSE'
        }
      }
    },
    component: () => import('@/views/Course/OfficeHour/List')
  },
  {
    path: '/course/office-hour/:courseId',
    name: 'course-office-hour-detail',
    meta: {
      title: 'Office Hour 课程详情',
      role: ROLES.STUDENT,
      topBar: TOP_BARS.BACK,
      backDefault: {
        name: 'course-office-hour'
      }
    },
    component: () => import('@/views/Course/OfficeHour/Detail')
  },
  {
    path: '/course/assignment-detail/:assignment_id',
    name: 'course-assignment-detail',
    component: () => import('@/views/Course/Period/Teacher/Seminar/Components/AssignmentDetail')
  },
  {
    path: '/course/assignment/participation/:course_id/:period?',
    name: 'course-assignment-participation',
    component: () => import('@/views/Course/Period/Teacher/Participation')
  },
  {
    path: '/course/period/:id/:period/:tab?',
    name: 'course-period',
    meta: {
      title: '课程详情',
      topBar: TOP_BARS.BACK,
      backDefault: {
        name: 'course-list'
      }
    },
    component: () => import('@/views/Course/Period')
  },
  /**
   * @description CoursePeriod 历史深链兼容，运行时统一由独立 Period 页面承接。
   */
  {
    path: '/course/detail/:id/:period',
    redirect: to => ({
      name: 'course-period',
      params: {
        id: to.params.id,
        period: to.params.period
      },
      query: to.query
    })
  },
  /**
   * @description Course 详情
   * @function /course/detail/:id Course 详情
   * @param { Component } Detail views/Course/Detail
   * @param { Name } pathname course-detail
   */
  {
    path: '/course/detail/:id',
    name: 'course-detail',
    meta: {
      title: '课程详情',
      topBar: TOP_BARS.BACK,
      backDefault: {
        name: 'course-list'
      }
    },
    component: () => import('@/views/Course/Detail')
  },
];
routes = routes.map(item => ({
  ...item,
  meta: Object.assign(
    {
      topBar: TOP_BARS.BY_ROLE,
      backDefault: {
        name: 'course-list'
      }
    },
    item.meta
  )
}));

export default routes;
